import {
	Component
} from '@angular/core';

@Component({
	selector: 'services',
	styleUrls: ['../styles/services.component.css'],
	templateUrl: '../views/services.component.html'
})

export class ServicesComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/services.component.ts